import * as React from "react";
const SvgInfoFilled = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0ZM8.75 5.15a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm0 2.25a.75.75 0 0 0-1.5 0V11a.75.75 0 0 0 1.5 0V7.4Z"
      fill="#886A2F"
    />
  </svg>
);
export default SvgInfoFilled;
